"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCoupleProperty = exports.couplePropertyDefinition = void 0;
exports.couplePropertyDefinition = {
    view: {
        label: 'Couple',
        style: 'horizontal',
    },
    constraints: [
        {
            name: 'orderedProperties',
            argument: ['couple-left-image', 'couple-right-image-or-quote'],
        },
    ],
    type: 'ordered-container',
    multiple: true,
    name: 'couple',
};
const isCoupleProperty = (prop) => {
    return prop.name === exports.couplePropertyDefinition.name;
};
exports.isCoupleProperty = isCoupleProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY291cGxlLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvY291cGxlLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsd0JBQXdCLEdBQUc7SUFDdEMsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLFFBQVE7UUFDZixLQUFLLEVBQUUsWUFBWTtLQUNwQjtJQUNELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLG1CQUFtQjtZQUN6QixRQUFRLEVBQUUsQ0FBQyxtQkFBbUIsRUFBRSw2QkFBNkIsQ0FBQztTQUMvRDtLQUNGO0lBQ0QsSUFBSSxFQUFFLG1CQUFtQjtJQUN6QixRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSxRQUFRO0NBQ2lCLENBQUE7QUFJMUIsTUFBTSxnQkFBZ0IsR0FBRyxDQUFDLElBQWtCLEVBQTBCLEVBQUU7SUFDN0UsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLGdDQUF3QixDQUFDLElBQUksQ0FBQTtBQUNwRCxDQUFDLENBQUE7QUFGWSxRQUFBLGdCQUFnQixvQkFFNUIifQ==